import {AbstractControl, FormGroup, ValidationErrors, ValidatorFn} from "@angular/forms";
import {EmailValidator} from "./email-validator";
import {Country} from "../../store/state/order.state";

export class UmbrellaValidators {

	static nonEmpty(control: AbstractControl): ValidationErrors | null {
		if (control.value != null && (control.value instanceof String || typeof control.value === 'string') && control.value !== '') {
			return (control.value as string).trim().length > 0 ? null : {empty: []};
		}

		return null;
	}

	static email(adminAllowed: boolean = false): ValidatorFn {
		return control => {
			if (control.value !== '') {
				return adminAllowed && control.value === 'admin' ?
					null :
					EmailValidator.validate(control);
			}
			return null;
		};
	}

	static phoneNumber(control: AbstractControl): ValidationErrors | null {
		const pattern = '^[1-9]\\d{1,12}$';
		if (control.value == null || control.value.isEmpty) {
			return null;
		}

		const phoneNumber = (control.value).toString();

		if (!new RegExp(pattern).test(phoneNumber)) {
			return {pattern: 'wrong phone number'} as ValidationErrors;
		}

		if (phoneNumber.length > 12) {
			return {pattern: 'wrong phone number'} as ValidationErrors;
		}

		return null;
	}

	static zipCode(control: AbstractControl, country: Country): ValidationErrors | null {
		if (control.value == null || control.value.isEmpty) {
			return null;
		}
		const zipCode = (control.value).toString();
		return new RegExp(country.zipCodeRegExp).test(zipCode) == true ? null : this.patternLabel(country, zipCode);

	}

	static patternLabel(country: Country, zipCode: string): ValidationErrors | null {
		if (zipCode.length == 0) {
			return null;
		}

		let error = {} as ValidationErrors;
		error[`pattern_${country.code.toLowerCase()}`] = [];
		return error;
	}


	static requiredLength(length: number): ValidatorFn {
		return control => {
			if (control.value != null && (control.value instanceof String || typeof control.value === 'string') && control.value !== '') {
				return (control.value as string).trim().length === length ? null : {requiredLength: []};
			} else if (control.value != null && typeof control.value === 'number') {
				const value = (control.value as number).toString();
				return value.length === length ? null : {requiredLength: []};
			}

			return null;
		};
	}

	static additionalFieldPattern(control: AbstractControl, countryCode: string, pattern: string): null | ValidationErrors {
		if (control.value != null && (control.value instanceof String || typeof control.value === 'string') && control.value !== '') {
			let value: string = control.value as string;
			let error = {} as ValidationErrors;
			error[`pattern_${countryCode.toLowerCase()}`] = [];
			return new RegExp(pattern).test(value) ? null : error;
		}

		return null;
	}

	static textLengthBetween(min: number, max: number): ValidatorFn {
		return control => {
			const belowMin = this.isBelowMin(control, min);
			const aboveMax = this.isAboveMax(control, max);

			if (belowMin == null && aboveMax == null) {
				return null;
			} else if (belowMin == null) {
				return aboveMax;
			} else {
				return belowMin;
			}
		};
	}

	static minLength(min: number): ValidatorFn {
		return control => {
			return this.isBelowMin(control, min);
		};
	}

	static radiobuttonRequired(): ValidatorFn {
		return control => control.value != null ? null : {radiobuttonRequired: []};
	}

	static minInteger(min: number) {
		return (control: AbstractControl) => {
			if (control.value === "" || control.value == null) {
				return null;
			} else if (!this.isInteger(control.value)) {
				return {min: []};
			} else if (Number(control.value) < min) {
				return {min: []};
			}
			return null;
		};
	}

	static maxInteger(max: number) {
		return (control: AbstractControl) => {
			if (control.value === "" || control.value == null) {
				return null;
			} else if (!this.isInteger(control.value)) {
				return {integer: []};
			} else if (Number(control.value) > max) {
				return {max: []};
			}
			return null;
		};
	}

	static isFloat(maxPrecision: number) {
		return (control: AbstractControl) => {
			if (control.value === "" || control.value == null) {
				return null;
			} else if (Number.isNaN(control.value)) {
				return {notNumber: []};
			} else if (this.getPrecision(control.value) > maxPrecision) {
				return {precisionTooHigh: []}
			}

			return null;
		};
	}

	private static getPrecision(value: number): number {
		let splitted: string[] = (value + "").split(/[.,]/);
		return splitted.length == 2 ? splitted[1].length : 0;

	}

	private static isInteger(value: string | number): boolean {
		return Number.isInteger(value);
	}

	static maxLength(min: number): ValidatorFn {
		return control => {
			return this.isAboveMax(control, min);
		};
	}

	private static isBelowMin(control: AbstractControl, min: number) {
		if (control.value != null && (control.value instanceof String || typeof control.value === 'string')) {
			return control.value === '' ? null : (control.value as string).trim().length >= min ? null : {minlength: []};-1
		}

		return null;
	}

	private static isAboveMax(control: AbstractControl, max: number) {
		if (control.value != null && (control.value instanceof String || typeof control.value === 'string')) {
			return (control.value as string).trim().length <= max ? null : {maxlength: []};
		}

		return null;
	}

	static matchPasswords(form: FormGroup) {
		const password = form.controls['password'].value;
		const repeatPassword = form.controls['repeatPassword'].value;
		if (repeatPassword !== password) {
			return {
				invalid: true
			};
		}

		return null;
	}
}
